<template>
  <div class="bg-gradient text-white">
    <div v-if="$device.isMobile">
      <nuxt />
    </div>
    <div v-else class="body-container">
      <Header />
      <b-container class="content my-4" fluid>
        <b-row class="h-100">
          <nuxt />
        </b-row>
      </b-container>
      <Footer />
    </div>
    <portal-target name="destination" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {}
  },
  computed: mapState(['user'])
}
</script>

<style>
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  height: 100%;
}

.bg-gradient {
  background: linear-gradient(-45deg, #869DE4,#4A2695, #4A2695, #869DE4);
}

.body {
  background: linear-gradient(-45deg, #869DE4,#4A2695, #4A2695, #869DE4);
}

.body-container {
  background: linear-gradient(-45deg, #869DE4,#4A2695, #4A2695, #869DE4);
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.content {
  flex: 1;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
